var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-form",
        { ref: "form", attrs: { model: _vm.form, "label-width": "120px" } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "知识名称" } },
            [
              _c("el-input", {
                staticClass: "input",
                attrs: { placeholder: "请输入需要查询的知识名称" },
                model: {
                  value: _vm.form.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "故事生成方式" } },
            [
              _c(
                "el-select",
                {
                  attrs: { placeholder: "请选择方式", clearable: true },
                  model: {
                    value: _vm.form.type,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "type", $$v)
                    },
                    expression: "form.type",
                  },
                },
                [
                  _c("el-option", {
                    attrs: { label: "问答形式-保险", value: "qa" },
                  }),
                  _c("el-option", {
                    attrs: { label: "问答形式-通用", value: "common" },
                  }),
                  _c("el-option", {
                    attrs: { label: "条款形式", value: "term" },
                  }),
                  _c("el-option", {
                    attrs: { label: "文本形式", value: "text" },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("el-button", { on: { click: _vm.fetchData } }, [
                _vm._v("查询"),
              ]),
              _c("el-button", { on: { click: _vm.addKnowledge } }, [
                _vm._v("上传"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          ref: "table",
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading",
            height: "48",
            border: "",
            "header-cell-style": { background: "rgb(244 244 244)" },
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "知识名称",
              "min-width": "180",
              fixed: "left",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.name) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "故事生成方式",
              "min-width": "180",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("typeFilter")(scope.row.identifyType)) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "创建人", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [_vm._v(" " + _vm._s(scope.row.createdBy) + " ")]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "上传模式", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm._f("modeFilter")(scope.row.origin)) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: "知识描述", "min-width": "180" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(scope.row.description || "暂无")),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "操作",
              "min-width": "220",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.delItem(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.queryItem(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          background: "",
          layout: "prev, pager, next",
          "pager-count": 15,
          total: _vm.totalNum,
        },
        on: { "current-change": _vm.handleCurrentChange },
      }),
      _c(
        "el-dialog",
        {
          staticClass: "text-dialog",
          attrs: {
            title: "知识块",
            visible: _vm.centerDialogVisible,
            "close-on-click-modal": false,
            width: "50%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.centerDialogVisible = $event
            },
          },
        },
        _vm._l(_vm.textBlocks, function (text) {
          return _c("div", { key: text }, [_vm._v(_vm._s(text))])
        }),
        0
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }